import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
    .use(HttpApi) // Load translations using http
    .use(LanguageDetector) // Detects user language
    .use(initReactI18next) // Passes i18n down to react-i18next
    .init({
        supportedLngs: ['de', 'en'],
        fallbackLng: 'de',
        debug: true,

        detection: {
            order: ['localStorage', 'cookie', 'navigator'],
            caches: ['localStorage', 'cookie'],
        },

        backend: {
            loadPath: '/locales/{{lng}}/translation.json',
        },

        interpolation: {
            escapeValue: false
        },
    });

export default i18n;